import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Tooltip, constants } from 'mage-deps/@klarna/bubble-ui'
import Popper from 'popper.js'

function getArrow(orientation) {
  switch (orientation) {
    case 'top':
      return 'bottom'
    case 'left':
      return 'right'
    case 'right':
      return 'left'
    default:
    case 'bottom':
      return 'top'
  }
}

function getSpacing(orientation) {
  switch (orientation) {
    case 'top':
      return { marginBottom: 5 }
    case 'left':
      return { marginRight: 5 }
    case 'right':
      return { marginLeft: 5 }
    case 'bottom':
      return { marginTop: 5 }
    default:
      return {}
  }
}

PositionedTooltip.propTypes = {
  orientation: PropTypes.oneOf(['bottom', 'top', 'left', 'right']),
  content: PropTypes.node,
  selector: PropTypes.string,
  id: PropTypes.string
}

function PositionedTooltip({
  selector,
  content,
  orientation,
  zIndex = constants.Layers.TOOLTIP,
  id
}) {
  const [targetElement, setTargetElement] = useState(null)
  const popper = useRef(null)
  // find the target dom element at the given selector
  useEffect(() => {
    const element = document.querySelector(selector)
    setTargetElement(element)
  }, [selector])
  const portalRef = React.useRef(document.createElement('div'))
  portalRef.current.style = `z-index: ${zIndex};`
  // create a an element that we can portal into
  useEffect(() => {
    const body = document.querySelector('body')
    body.appendChild(portalRef.current)
    return () => portalRef.current && portalRef.current.remove()
  }, [])
  // use popper.js to position the tooltip rendered into the portal next to the target element
  useEffect(() => {
    if (targetElement && portalRef) {
      setTimeout(() => {
        popper.current = new Popper(targetElement, portalRef.current, { // eslint-disable-line
          modifiers: {
            applyStyle: { enabled: true },
            placement: orientation
          },
          placement: orientation
        })
      }, 0)
      return () => {
        if (popper.current) {
          popper.current.destroy()
        }
      }
    }
  }, [targetElement, orientation])
  if (!targetElement) {
    return null
  }

  return ReactDOM.createPortal(
    <div style={getSpacing(orientation)} id={id}>
      <Tooltip arrow={getArrow(orientation)}>{content}</Tooltip>
    </div>,
    portalRef.current
  )
}

export default PositionedTooltip
